import { useEffect, useState } from 'react'
import { t } from '../locale'
import { getServiceDetails } from '../helpers/services.helper'

function ServiceOverviewTable() {
  const [serviceCosts, setServiceCosts] = useState<Record<string, number | string> | null>(null)

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/subscription/service-costs`)
      .then(r => r.json())
      .then(r => {
        if (r && typeof r === 'object') setServiceCosts(r)
      })
  }, [])

  return (
    <div className='table-responsive'>
      <table className='table table-sm table-hover'>
        <thead>
          <tr>
            <th className='text-primary smaller'>{t('service')}</th>
            <th className='text-primary smaller'>{t('description')}</th>
            <th className='text-primary smaller text-end'>{t('pointCost')}</th>
          </tr>
        </thead>
        <tbody>
          {getServiceDetails().map((s, i) => (
            <tr key={i}>
              <td className='smaller text-draft fw-medium'>{s.label}</td>
              <td className='smaller text-draft'>{s.desc}</td>
              <td className='smaller text-end'>
                {s.costKey === undefined ? (
                  <span className='text-draft fst-italic'>{t('free')}</span>
                ) : serviceCosts?.[s.costKey as keyof typeof serviceCosts] === 0 ? (
                  <span className='text-success'>{t('serviceFree')}</span>
                ) : (
                  <span className='text-primary fw-medium'>
                    {serviceCosts?.[s.costKey as keyof typeof serviceCosts] ?? '—'}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ServiceOverviewTable
